<template>
  <div id="app" class="h-full w-full overflow-hidde">
    <intro />
    <router-view />
    <div
      v-if="menu"
      class="fixed block lg:hidden bottom-0 left-0 px-4 w-screen z-50"
      @click="goHome()"
    >
      <div class="border-t border-black px-4 py-3 cursor-pointer text-center text-xs tracking-widest">
        MENU
      </div>
    </div>
  </div>
</template>

<script>
const Intro = () =>
  import(/* webpackChunkName: "Intro" */ "@/components/Intro.vue");
import { mapState } from "vuex";
export default {
  name: "App",
  metaInfo() {
    return {
      titleTemplate: "BIM'21" + " %s",
    };
  },
  data() {
    return {
      menu: false,
    };
  },
  components: {
    Intro,
  },
  mounted() {
    window.onpopstate = () => {
      let hashtag = document.location.hash.substring(1);
      if(hashtag) {
        this.menu = true;
        this.$root.$emit('openMenu');
        this.$root.$emit("goToPage", hashtag);
      } else {
        this.menu = false;
        if(window.innerWidth > 768) {
          this.$root.$emit('closeMenu');
        } else {
          this.goHome();
        }
        
      }
    }
    this.$root.$on("openPage", () => {
      this.menu = true;
    });
    this.$root.$on("closePage", () => {
      this.menu = false;
    });
    this.$root.$on("goToHome", this.goHome);
    setTimeout(() => {
      if(window.location.hash) {
        let hashtag = document.location.hash.substring(1);
        this.menu = true;
        this.$root.$emit("openMenu");
        this.$root.$emit("goToPage", hashtag);
      }
    }, 500);
  },
  computed: mapState(["site"]),
  created() {
    this.$store.dispatch("loadSite");
  },
  methods: {
    goHome() {
      this.$root.$emit('goHome'); 
      this.menu = false
      history.pushState('home', document.title, window.location.pathname)
    }
  }
};
</script>
